import createClient from 'openapi-fetch'
import type { HeadersOptions } from 'openapi-fetch'
import { errorResponseMiddleware } from './middleware/errorResponseMiddleware'
import { responseMiddleware } from './middleware/responseMiddleware'

export function fetchClient<T extends {}>({ baseUrl, headers } : { baseUrl: string, headers?: HeadersOptions }) {
  const client = createClient<T>({ baseUrl, headers })
  client.use(errorResponseMiddleware)
  client.use(responseMiddleware)
  return client
}